import { render, staticRenderFns } from "./Board.vue?vue&type=template&id=5bc61ee7&scoped=true"
import script from "./Board.vue?vue&type=script&lang=ts"
export * from "./Board.vue?vue&type=script&lang=ts"
import style0 from "./Board.vue?vue&type=style&index=0&id=5bc61ee7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc61ee7",
  null
  
)

export default component.exports